import { render } from "./EmailConfirmPage.vue?vue&type=template&id=768772a3&scoped=true"
import script from "./EmailConfirmPage.vue?vue&type=script&lang=js"
export * from "./EmailConfirmPage.vue?vue&type=script&lang=js"

import "./EmailConfirmPage.vue?vue&type=style&index=0&id=768772a3&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768772a3"]])

export default __exports__